/* Sample landing page interactivity. Boots only when #smpRoot is present. */
(function () {
  if (window.__smpSampleInited) return;
  window.__smpSampleInited = true;

  function init() {
    var root = document.getElementById('smpRoot');
    if (!root) return;

    var form = root.querySelector('#smp-customer-form');
    if (!form) return;

    var maxPicks = parseInt(root.dataset.maxPicks || '2', 10);
    var minPicks = parseInt(root.dataset.minPicks || '2', 10);
    var selected = [];

    var recipes = [].slice.call(root.querySelectorAll('[data-recipe]'));
    var counter = root.querySelector('[data-count]');
    var countMax = root.querySelector('[data-count-max]');
    var countEmoji = root.querySelector('[data-count-emoji]');
    var error = root.querySelector('[data-error]');
    var submitBtn = root.querySelector('[data-submit]');
    var dogNameInput = root.querySelector('[data-dog-name]');
    var greetEls = root.querySelectorAll('[data-greet], [data-greet-name]');

    if (countMax) countMax.textContent = String(maxPicks);

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function renderRecipes() {
      recipes.forEach(function (r) {
        var picked = selected.indexOf(r.dataset.key) > -1;
        r.classList.toggle('is-selected', picked);
        r.classList.toggle('is-disabled', !picked && selected.length >= maxPicks);
      });
      if (counter) counter.textContent = String(selected.length);
      if (countEmoji) {
        countEmoji.textContent = selected.length === 0 ? '🐾'
          : selected.length === 1 ? '🐾🐾' : '🐾🐾✨';
      }
    }

    recipes.forEach(function (r) {
      r.addEventListener('click', function (e) {
        if (e.target.closest('[data-recipe-toggle]')) return;
        var key = r.dataset.key;
        var idx = selected.indexOf(key);
        if (idx > -1) selected.splice(idx, 1);
        else { if (selected.length >= maxPicks) return; selected.push(key); }
        hideError();
        renderRecipes();
      });
    });

    root.querySelectorAll('[data-recipe-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('[data-recipe]');
        if (!card) return;
        var open = card.classList.toggle('is-expanded');
        var openLabel = btn.dataset.labelOpen || 'Got it';
        var closedLabel = btn.dataset.labelClosed || "What's inside?";
        btn.textContent = open ? openLabel : closedLabel;
      });
    });

    /* FAQ */
    document.querySelectorAll('.smp-faq-q').forEach(function (q) {
      q.addEventListener('click', function () { q.parentElement.classList.toggle('is-open'); });
    });

    /* Greeting */
    function renderGreeting() {
      var name = (dogNameInput && dogNameInput.value.trim()) || '';
      greetEls.forEach(function (el) {
        if (el.dataset.greet !== undefined) {
          el.innerHTML = name ? escapeHtml(name) + '! 👋' : '<span>your future best friend\'s pup</span>';
        } else {
          el.textContent = name || 'your pup';
        }
      });
    }
    if (dogNameInput) dogNameInput.addEventListener('input', renderGreeting);

    function showError(msg) { if (!error) return; if (msg) error.textContent = msg; error.classList.add('is-visible'); }
    function hideError() { if (error) error.classList.remove('is-visible'); }

    /* Breed autocomplete */
    var breedWrap = root.querySelector('[data-breed-wrap]');
    var breedInput = root.querySelector('[data-breed-input]');
    var breedList = root.querySelector('[data-breed-list]');
    var breedHidden = root.querySelector('[data-breed-hidden]');
    var allBreeds = [];
    var POPULAR = [
      'Mixed breed', 'Other', 'Labrador Retriever', 'Golden Retriever',
      'French Bulldog', 'German Shepherd', 'Bulldog', 'Cocker Spaniel',
      'Border Collie', 'Cavalier King Charles Spaniel', 'Cockapoo',
      'Beagle', 'Dachshund', 'Shih Tzu', 'Poodle'
    ];
    var activeIdx = -1;

    function loadBreeds() {
      var url = root.dataset.breedsUrl;
      if (!url) return;
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (Array.isArray(data)) allBreeds = data; renderBreedList(''); })
        .catch(function () {});
    }
    function renderBreedList(query) {
      if (!breedList) return;
      var q = (query || '').toLowerCase().trim();
      var html = '';
      if (!q) {
        var popularPresent = allBreeds.filter(function (b) { return POPULAR.indexOf(b) > -1; });
        var rest = allBreeds.filter(function (b) { return POPULAR.indexOf(b) === -1; });
        popularPresent.sort(function (a, b) { return POPULAR.indexOf(a) - POPULAR.indexOf(b); });
        if (popularPresent.length) {
          html += '<div class="smp-breed-group-label">Popular picks</div>';
          popularPresent.forEach(function (b) { html += '<div class="smp-breed-option" role="option" data-value="' + escapeHtml(b) + '">' + escapeHtml(b) + '</div>'; });
        }
        var byLetter = {};
        rest.forEach(function (b) { var L = b.charAt(0).toUpperCase(); (byLetter[L] = byLetter[L] || []).push(b); });
        Object.keys(byLetter).sort().forEach(function (L) {
          html += '<div class="smp-breed-group-label">' + L + '</div>';
          byLetter[L].sort().forEach(function (b) { html += '<div class="smp-breed-option" role="option" data-value="' + escapeHtml(b) + '">' + escapeHtml(b) + '</div>'; });
        });
      } else {
        var matches = allBreeds.filter(function (b) { return b.toLowerCase().indexOf(q) > -1; }).slice(0, 50);
        if (matches.length === 0) {
          html = '<div class="smp-breed-empty">Can\'t find it? <br><button type="button" data-breed-other>Use "Other"</button></div>';
        } else {
          matches.forEach(function (b) { html += '<div class="smp-breed-option" role="option" data-value="' + escapeHtml(b) + '">' + escapeHtml(b) + '</div>'; });
        }
      }
      breedList.innerHTML = html;
      activeIdx = -1;
    }
    function setBreed(value) {
      if (!breedInput) return;
      breedInput.value = value;
      if (breedHidden) breedHidden.value = value;
      if (breedWrap) { breedWrap.classList.remove('is-open'); breedWrap.classList.toggle('has-value', !!value); }
    }
    if (breedInput && breedList && breedWrap) {
      breedInput.addEventListener('focus', function () { breedWrap.classList.add('is-open'); renderBreedList(breedInput.value); });
      breedInput.addEventListener('input', function () { breedWrap.classList.add('is-open'); renderBreedList(breedInput.value); });
      breedInput.addEventListener('keydown', function (e) {
        var opts = breedList.querySelectorAll('.smp-breed-option');
        if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(opts.length - 1, activeIdx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(0, activeIdx - 1); }
        else if (e.key === 'Enter') { if (activeIdx >= 0 && opts[activeIdx]) { e.preventDefault(); setBreed(opts[activeIdx].dataset.value); return; } }
        else if (e.key === 'Escape') { breedWrap.classList.remove('is-open'); return; }
        else { return; }
        opts.forEach(function (o, i) { o.classList.toggle('is-active', i === activeIdx); });
        if (opts[activeIdx]) opts[activeIdx].scrollIntoView({ block: 'nearest' });
      });
      breedList.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-value]');
        if (opt) { setBreed(opt.dataset.value); return; }
        if (e.target.closest('[data-breed-other]')) setBreed('Other');
      });
      document.addEventListener('click', function (e) {
        if (!breedWrap.contains(e.target)) breedWrap.classList.remove('is-open');
      });
    }
    loadBreeds();

    /* Submit — native POST to /cart/add with return_to=/checkout. Shopify
       processes server-side: adds items, applies discount via the chained
       return_to redirect, lands the user directly on /checkout. */

    function getPicked() {
      return selected.map(function (key) {
        var el = root.querySelector('[data-recipe][data-key="' + key + '"]');
        return el ? { variantId: el.dataset.variantId, title: el.dataset.title } : null;
      }).filter(function (p) { return p && p.variantId; });
    }

    function appendInput(form, name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value == null ? '' : value;
      form.appendChild(input);
    }

    /* Per-field validation helpers */
    function setFieldError(name, msg) {
      var input = form.querySelector('[data-validate="' + name + '"]');
      var slot = form.querySelector('[data-field-error="' + name + '"]');
      if (input) input.classList.toggle('is-invalid', !!msg);
      if (slot) {
        slot.textContent = msg || '';
        slot.classList.toggle('is-visible', !!msg);
      }
    }
    function clearAllFieldErrors() {
      form.querySelectorAll('[data-validate]').forEach(function (i) { i.classList.remove('is-invalid'); });
      form.querySelectorAll('[data-field-error]').forEach(function (s) { s.classList.remove('is-visible'); s.textContent = ''; });
    }
    /* Clear a field's error as soon as user fixes it */
    form.querySelectorAll('[data-validate]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.classList.contains('is-invalid')) setFieldError(input.dataset.validate, '');
      });
    });

    function flashRecipeCounter() {
      var c = root.querySelector('.smp-recipes-counter');
      if (!c) return;
      c.classList.add('is-invalid');
      setTimeout(function () { c.classList.remove('is-invalid'); }, 1200);
    }

    if (form && submitBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        clearAllFieldErrors();
        hideError();

        var firstName = (form.querySelector('[name="first_name"]') || {}).value.trim();
        var lastName  = (form.querySelector('[name="last_name"]')  || {}).value.trim();
        var email     = (form.querySelector('[name="email"]')      || {}).value.trim();
        var phone     = (form.querySelector('[name="phone"]')      || {}).value.trim();

        var problems = [];
        if (!firstName) { setFieldError('firstName', 'Please add your first name.'); problems.push('firstName'); }
        if (!lastName)  { setFieldError('lastName',  'Please add your last name.');  problems.push('lastName'); }
        if (!/^\S+@\S+\.\S+$/.test(email)) { setFieldError('email', "That email doesn't look quite right."); problems.push('email'); }
        if (phone) {
          /* Phone is optional, but if provided it must look like a UK number.
             Strip non-digits, normalise +44 / 0044 → leading 0, then require
             a 10–11 digit number starting with 0[1-9]. Accepts: 07700 900123,
             +44 7700 900123, (0044) 20 7946 0958, 020 7946 0958. */
          var phoneDigits = phone.replace(/\D/g, '');
          if (/^00/.test(phoneDigits)) phoneDigits = phoneDigits.substring(2);
          if (/^44/.test(phoneDigits)) phoneDigits = '0' + phoneDigits.substring(2);
          if (!/^0[1-9]\d{8,9}$/.test(phoneDigits)) {
            setFieldError('phone', "That doesn't look like a UK phone number.");
            problems.push('phone');
          }
        }

        var picked = getPicked();
        var recipeOk = selected.length >= minPicks && picked.length >= minPicks;
        if (!recipeOk) {
          showError('Please pick ' + minPicks + ' recipe' + (minPicks === 1 ? '' : 's') + ' before you submit.');
          flashRecipeCounter();
          problems.push('recipes');
        }

        if (problems.length > 0) {
          if (problems[0] !== 'recipes') {
            var firstInvalid = form.querySelector('.is-invalid');
            if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus({ preventScroll: true });
          }
          return;
        }

        var dogName = (dogNameInput && dogNameInput.value.trim()) || '';
        var breed = (breedInput && breedInput.value.trim()) || '';
        var recipeTitles = picked.map(function (p) { return p.title; });
        var customerTagInput = form.querySelector('[data-customer-tag]');
        var customerTag = customerTagInput ? customerTagInput.value : 'sample-campaign';

        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;

        /* Single native POST to /cart/add. Lead data rides along as:
           - line item properties (per item: For, Breed, _Sample)
           - cart attributes (Customer name/email/phone/tag, dog details)
           - checkout email prefill in return_to URL
           No /contact endpoint, no /challenge redirect. */
        var cartForm = document.createElement('form');
        cartForm.method = 'post';
        cartForm.action = '/cart/add';
        cartForm.style.display = 'none';

        picked.forEach(function (p, i) {
          appendInput(cartForm, 'items[' + i + '][id]', p.variantId);
          appendInput(cartForm, 'items[' + i + '][quantity]', 1);
          if (dogName) appendInput(cartForm, 'items[' + i + '][properties][For]', dogName);
          if (breed)   appendInput(cartForm, 'items[' + i + '][properties][Breed]', breed);
          appendInput(cartForm, 'items[' + i + '][properties][_Sample]', 'true');
        });

        /* Cart-level attributes — visible in Admin → Orders / Abandoned Checkouts */
        appendInput(cartForm, 'attributes[Customer name]', (firstName + ' ' + lastName).trim());
        appendInput(cartForm, 'attributes[Customer email]', email);
        appendInput(cartForm, 'attributes[Customer phone]', phone);
        if (dogName) appendInput(cartForm, 'attributes[Dog name]', dogName);
        if (breed) appendInput(cartForm, 'attributes[Dog breed]', breed);
        appendInput(cartForm, 'attributes[Source]', customerTag);
        appendInput(cartForm, 'attributes[Picked recipes]', recipeTitles.join(' + '));

        /* Final destination: /checkout. Shopify reads this from return_to and
           redirects there after successfully adding the items. The 100% off
           is applied server-side by the paws-sampling-app Function, gated on
           the items[i][properties][_Sample] = "true" line item property
           appended above. No URL discount chain needed.

           We also pre-fill the checkout contact + shipping name fields via
           query params on return_to so the customer doesn't re-type what
           they just gave us on the funnel form. UK is the only locale we
           ship samples to, so we hard-code GB as the country. */
        var checkoutParams = new URLSearchParams();
        checkoutParams.set('checkout[email]', email);
        checkoutParams.set('checkout[shipping_address][first_name]', firstName);
        checkoutParams.set('checkout[shipping_address][last_name]', lastName);
        checkoutParams.set('checkout[shipping_address][country]', 'United Kingdom');
        if (phone) checkoutParams.set('checkout[shipping_address][phone]', phone);
        appendInput(cartForm, 'return_to', '/checkout?' + checkoutParams.toString());

        /* Clear any pre-existing cart so the sample funnel is a clean
           "2 free meals + postage" checkout, not "free meals + whatever
           was already in cart + postage". /cart/clear.js wipes both items
           and cart attributes; we then submit the prepared sample cart. */
        function submitSampleCart() {
          document.body.appendChild(cartForm);
          cartForm.submit();
        }
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        })
          .then(submitSampleCart)
          .catch(submitSampleCart);
      });
    }

    renderRecipes();
    renderGreeting();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

